module.exports = __webpack_public_path__ + "img/camp07_open.54c99917.png";